import React, { useEffect, useState } from 'react'
import { Box, Button, Container, Stack } from '../imports/muiImport'
import { Helmet } from 'react-helmet-async'


import { DesktopLoginImage, Logo99, useLocation, useNavigate } from '../imports/generalImport';
import LoginPage from './LoginPage';
import SignupPage from './SignupPage';
import PasswordReset from './PasswordResetPage';
import "./DesktopAuthLayoutStyles.css";


const DesktopAuthLayout = () => {
  const [pageShow, setPageShow] = useState("/login");

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setPageShow(location.pathname);
  }, [location]);


  return (
    <Container
      maxWidth="false"
      sx={{
        bgcolor: "#e6f9ff",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 6,
      }}
    >
      {pageShow === "/login" &&
        <Helmet>
          <title>Login -99gift.in</title>
          <meta property="og:title" content="Login -99gift.in" />
        </Helmet>
      }

      {pageShow === "/signup" &&
        <Helmet>
          <title>Signup -99gift.in</title>
          <meta property="og:title" content="Signup -99gift.in" />
        </Helmet>
      }

      {pageShow === "/password-reset" &&
        <Helmet>
          <title>password-reset -99gift.in</title>
          <meta property="og:title" content="Signup -99gift.in" />
        </Helmet>
      }

      <Container
        maxWidth="lg"
        disableGutters
        sx={{
          minHeight: "95vh",
          display: "grid",
          gridTemplateColumns: {
            sm: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
          },
          columnGap: 0,
          rowGap: 0,

          boxShadow: 4,
          borderRadius: 4,
          overflow: "hidden",
          backgroundColor: "white.main",
        }}
      >
        <Box
          component={"div"}
          sx={{
            width: "100%",
            maxWidth: {
              sm: "80%",
              md: "80%",
              lg: "90%"
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: 8,
            pb: 4,
            mx: "auto"
          }}
        >
          <Box
            component={"div"}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}>
            <Box
              component={'img'}
              src={Logo99}
              width={170}
              sx={{
                mixBlendMode: "multiply",
                mx: "auto",
              }}
            />
          </Box>

          <Box
            component={"div"}
            sx={{
              mt: 3,
              display: pageShow === "/password-reset" && "none"
            }}
          >
            <Stack
              direction="row"
              spacing={2}
              className="login__form_buttonSwitch"
            >
              <Button
                variant="text"
                className={`login__button ${pageShow === "/login" ? "active" : ""}`}
                onClick={() => navigate("/login")}
              >
                Log in
              </Button>
              <Button
                variant="text"
                className={`login__button ${pageShow === "/signup" ? "active" : ""}`}
                onClick={() => navigate("/signup", { replace: true })}
              >
                Sign Up
              </Button>
            </Stack>
          </Box>

          <Box
            component={"div"}
            sx={{
              width: {
                sm: "100%",
                lg: "70%",
              }
            }}
          >
            {pageShow === "/login" && <LoginPage />}
            {pageShow === "/signup" && <SignupPage />}
            {pageShow === "/password-reset" && <PasswordReset />}
          </Box>

        </Box>

        <Box
          component={"div"}
          sx={{
            height: "100%",
            width: "100%",
          }}
        >
          <Box
            component="img"
            src={DesktopLoginImage}
            alt="LoginImage"
            loading="lazy"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Container>
    </Container>
  )
}

export default DesktopAuthLayout